export enum MaccsBoxReportType {
  GBO = 0,
  BOR = 1,
}

export const maccsBoxReportTypeTranslations: Record<MaccsBoxReportType, string> = {
  [MaccsBoxReportType.GBO]: 'maccsbox_reports.type_gbo',
  [MaccsBoxReportType.BOR]: 'maccsbox_reports.type_bor',
};
